import { c as _c } from "react/compiler-runtime";
import React from 'react';
import type { AccordionGroupProps } from './Accordion.types';
export function AccordionGroup(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] !== children) {
    const accordions = React.Children.toArray(children);
    t1 = "mt-4";
    t2 = accordions.map(_temp);
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <ul className={t1}>{t2}</ul>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp(accordion, index) {
  return <li className="py-2 border-t last:border-b" key={index}><div className="-mx-2">{accordion}</div></li>;
}